import Vue from "vue";
import VueRouter from "vue-router";
import Main from "@/views/main/main-entry.vue";
import store from '@/store/index';
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/home",
    component: Main,
    children: [
      {
        path: "/home",
        name: "/home",
        component: () => import("@/views/home/home.vue"),
      },
      {
        path: "/tradingSquare",
        name: "/tradingSquare",
        component: () => import("@/views/tradingSquare/index.vue"),
      },
      {
        path: "/productPackage",
        name: "/productPackage",
        component: () => import("@/views/productPackage/index.vue"),
      },
      {
        path: "/complianceStudy",
        name: "/complianceStudy",
        component: () => import("@/views/complianceStudy/index.vue"),
      },
      {
        path: "/contactUs",
        name: "/contactUs",
        component: () => import("@/views/contactUs/index.vue"),
      },
      {
        path: "/freeTrial",
        name: "/freeTrial",
        component: () => import("@/views/freeTrial/index.vue"),
      },
      {
        path: "/classroom",
        name: "/classroom",
        component: () => import("@/views/classroom/index.vue"),
      },
      {
        path: "/tables",
        name: "/tables",
        component: () => import("@/views/tables/index.vue"),
      },
      {
        path: "/login",
        name: "/login",
        component: () => import("@/views/login/index.vue"),
      },
      {
        path: "/study",
        name: "/study",
        component: () => import("@/views/tables/study.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

// 兼容ie11 手动触发hashchange
if (
  "-ms-scroll-limit" in document.documentElement.style &&
  "-ms-ime-align" in document.documentElement.style
) {
  window.addEventListener(
    "hashchange",
    () => {
      let currentPath = window.location.hash.slice(1);
      if (router.path !== currentPath) {
        router.push(currentPath);
      }
    },
    false
  );
}
router.beforeEach((to, from, next) => {
  //from中包含跳转前的路由信息，to包含跳转到的目的路由信息
  if (to.fullPath == "/tables" || to.fullPath == "/study" ) {
    // if (store.state.isToken) {
    if (sessionStorage.getItem('isToken')) {
      next()
    } else {
      next({
        path: "/login",
        // query: { redirect: to.fullPath },
      }); // 将跳转的路由path作为参数，登录成功后跳转到该路由
    }
  } else {
    next();
  }
});
router.afterEach((to, from) => {
  window.scroll({
    top: 0,
    left: 0,
  });
});

export default router;
